var map = {
	"./erweima.jpg": "bedd",
	"./footpre.jpg": "9fda",
	"./icon-douyin.png": "b1e1",
	"./icon-gongan.png": "d2b1",
	"./icon-jingdong.png": "12ce",
	"./icon-sv1.png": "dcf0",
	"./icon-sv2.png": "12e4",
	"./icon-sv3.png": "f17f",
	"./icon-sv4.png": "47d8",
	"./icon-sv5.png": "8e51",
	"./icon-t1.png": "d610",
	"./icon-t2.png": "6910",
	"./icon-t3.png": "d5a5",
	"./icon-t4.png": "8da5",
	"./icon-taobao.png": "b153",
	"./icon_dcp.png": "7893",
	"./reject.png": "0eb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";